import React from "react";
import { Card, Col, Progress, Rate, Space, Tag, Typography } from "antd";
import { transformSingleResponseData } from "../../../../utils/surveys";

const QuestionResponsesSelect = ({ question }) => {
    return (
        <Col span={24}>
            <Card
                bordered={true}
                style={{
                    background: "#fafafa",
                    textAlign: "left",
                }}
            >
                <Typography.Title level={4}>
                    {question.headline}
                </Typography.Title>
                <div
                    style={{
                        marginTop: "20px",
                    }}
                >
                    <Tag color="blue">
                        {question.type === "multipleChoiceMulti"
                            ? "Multi-Select"
                            : "Single-Select"}
                    </Tag>
                    <Tag color="orange">
                        {question.responses.length}{" "}
                        {question.responses.length === 1
                            ? "response"
                            : "responses"}
                    </Tag>
                </div>
                <Space
                    direction="vertical"
                    size="large"
                    style={{ marginTop: "50px", width: "100%" }}
                >
                    {question?.choices?.map((choice) => (
                        <div key={choice.id}>
                            <Space
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Space size="large">
                                    <Typography>{choice.label}</Typography>
                                    <Tag bordered={false}>
                                        {transformSingleResponseData(
                                            question,
                                            choice.label
                                        ).overallPercentage || 0}{" "}
                                        %
                                    </Tag>
                                </Space>
                                <Tag bordered={false}>
                                    {
                                        transformSingleResponseData(
                                            question,
                                            choice.label
                                        ).count
                                    }{" "}
                                    {transformSingleResponseData(
                                        question,
                                        choice.label
                                    ).count === 1
                                        ? "response"
                                        : "responses"}
                                </Tag>
                            </Space>
                            <Progress
                                percent={
                                    transformSingleResponseData(
                                        question,
                                        choice.label
                                    ).overallPercentage
                                }
                                status="active"
                                size="default"
                                showInfo={false}
                            />
                        </div>
                    ))}
                </Space>
            </Card>
        </Col>
    );
};

export default QuestionResponsesSelect;
